module.exports = __webpack_public_path__ + "static/media/ic-category-list-on.0a9095f3.svg";